












































import { Component, Vue } from 'vue-property-decorator'
import { Offer } from '@/api/model/offer'
import { OfferAPI } from '@/api/backend-client'

@Component
export default class MarketplaceList extends Vue {
    offers: Offer[] = []
    loading: boolean = false
    selectedFilters: string[] = []

    async mounted(): Promise<void> {
        await this.loadOffers()
    }

    async loadOffers(): Promise<void> {
        this.loading = true
        this.offers = await OfferAPI.getAll()
        if (this.$route.query.filter) {
            this.selectedFilters = this.$route.query.filter instanceof Array ? this.$route.query.filter : [this.$route.query.filter]
        }
        this.loading = false
    }

    async routeToDetail(offer: Offer): Promise<void> {
        await this.$router.push({
            name: 'marketplace_detail',
            params: {
                offerId: offer.id,
            },
        })
    }

    generateMailToLink(offer: Offer): string {
        return `mailto:vraag@marketingperron.nl` +
            `?subject=Vraag over pakket '${offer.name}' in KeyVue`
    }

    get availableFilters() {
        return [...new Set(this.offers.flatMap(offer => offer.tags))]
            .map(entry => ({
                label: entry,
                value: entry,
            }))
            .sort(((a, b) => a.label.localeCompare(b.label)))
    }

    get filteredOffers(): Offer[] {
        return this.selectedFilters.length === 0 ? this.offers : this.offers
            .filter(offer => {
                return offer.tags.some(tag => this.selectedFilters.includes(tag))
            })
    }
}
